module.exports = __webpack_public_path__ + "static/media/pres83.dfba6f84.png";